<template>
  <transition name="overlay" appear>
    <div v-if="open" class="overlay" @click="$emit('close')" />
  </transition>
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0.2;
  background-color: #32302e;
  z-index: z-index(overlay);

  &-enter-active,
  &-leave-active {
    transition: opacity 0.3s ease-in-out;
  }

  &-enter,
  &-leave-to {
    opacity: 0;
  }
}
</style>
